import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="distance"
export default class extends Controller {
  static values = {
    lat: Number,
    lng: Number,
  };
  static targets = ["output"];

  connect() {
    if (!this.hasLatValue || !this.hasLngValue) return;

    // STEP A: Render instantly using the best available cached coordinates
    const cachedLat = parseFloat(sessionStorage.getItem("user_latitude"));
    const cachedLng = parseFloat(sessionStorage.getItem("user_longitude"));

    if (cachedLat && cachedLng) {
      this.calculateAndUpdate(cachedLat, cachedLng);
    } else {
      // Fallback if the app was cold-booted directly into a sub-page
      const urlParams = new URLSearchParams(window.location.search);
      const urlLat = parseFloat(urlParams.get("latitude"));
      const urlLng = parseFloat(urlParams.get("longitude"));
      if (urlLat && urlLng) this.calculateAndUpdate(urlLat, urlLng);
    }
  }

  // STEP B: Run calculations dynamically whenever watchPosition broadcasts a movement update
  update(event) {
    this.calculateAndUpdate(event.detail.lat, event.detail.lng);
  }

  calculateAndUpdate(userLat, userLng) {
    if (!this.hasLatValue || !this.hasLngValue) return;

    const distanceKm = this.calculateHaversine(
      userLat,
      userLng,
      this.latValue,
      this.lngValue,
    );

    if (distanceKm < 1) {
      const meters = Math.round(distanceKm * 1000);
      this.outputTarget.textContent = `${meters} m away`;
    } else {
      this.outputTarget.textContent = `${distanceKm.toFixed(1)} km away`;
    }
  }

  calculateHaversine(lat1, lon1, lat2, lon2) {
    const R = 6371;
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }
}
